import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import MenuDrawer from "../MenuDrawer/MenuDrawer";
import { useStyles } from "./AdminDrawer.css";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";

class AdminHeader extends Component {
  render() {
    const { classes, open, schoolDetails, role } = this.props;
    return (
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {open === true && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {schoolDetails.schoolLogo ? (
                <img
                  src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
                  alt="School Logo"
                  style={{ width: 100, height: 100 }}
                />
              ) : (
                <div>Admin Panel</div>
              )}
              <IconButton
                onClick={this.props.handleDrawerClose}
                style={{ background: "transparent" }}
              >
                {"rtl" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
          )}
        </div>

        <Divider />
        <div className={classes.scrollDraw}>
          <MenuDrawer open={open} role={role} />
        </div>
      </Drawer>
    );
  }
}

export default withStyles(useStyles)(AdminHeader);
